import ForgetStore from './ForgetStore';
import ModifyStore from './ModifyStore';
import SignInStore from './SignInStore';
import SignUpStore from './SignUpStore';

export interface AccountStoreTypes {
    ForgetStore:  ForgetStore;
    ModifyStore:  ModifyStore;
    SignInStore:  SignInStore;
    SignUpStore:  SignUpStore;
}


const AccountStore = {
    ForgetStore: new ForgetStore(),
    ModifyStore: new ModifyStore(),
    SignInStore: new SignInStore(),
    SignUpStore: new SignUpStore()
}

export default AccountStore;
